// extracted by mini-css-extract-plugin
var _1 = "zWqHtdfHsNQ1zohNWGB5";
export { _1 as "container" }
